/* eslint-disable */
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BloodyLitersTrucks } from '../BloodyLitersTrucks/BloodyLitersTrucks';
import { ExpandMoreIconCustom } from '../globalStyles';
import OpenEmsListEvPowerBanner from '../OpenEmsListEvPowerBanner/OpenEmsListEvPowerBanner';
import { formatHistoryKwh, formatImpactCount, formatImpactCo2Tons, globalImpactFromLitersSaved } from '../../pages/historyPage/historyChartImpact';

/** Global network impact — trucks hero + collapsible live power / kWh / A-95 / CO₂ (list page). */
export default function GlobalChargeImpactSummary({ liters, className = '' }) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const { totalKwh, litersSaved, co2KgSaved } = useMemo(
    () => globalImpactFromLitersSaved(liters),
    [liters]
  );

  return (
    <div className={`charge-impact-summary ${className}`.trim()}>
      <button
        type="button"
        className={`charge-impact-summary__toggle${expanded ? ' charge-impact-summary__toggle--expanded' : ''}`}
        onClick={() => setExpanded(prev => !prev)}
        aria-expanded={expanded}
        aria-controls="charge-impact-summary-panel"
      >
        <span className="charge-impact-summary__toggle-title">{t('historyPage.revenueChartSummaryAria')}</span>
        <ExpandMoreIconCustom className="charge-impact-summary__toggle-icon" aria-hidden />
      </button>
      {expanded && (
        <div id="charge-impact-summary-panel" className="charge-impact-summary__panel">
          <div className="charge-impact-summary__hero">
            <span className="charge-impact-summary__hero-label">{t('getBloodyLitersSaved')}:</span>
            <a
              href={t('bloodyLitersLink')}
              className="bloody-liters-trucks-link charge-impact-summary__hero-link"
            >
              <BloodyLitersTrucks liters={litersSaved} />
            </a>
          </div>
          <OpenEmsListEvPowerBanner className="charge-impact-summary__power-banner" />
          <ul className="charge-impact-summary__grid" aria-label={t('historyPage.revenueChartSummaryAria')}>
            <li className="charge-impact-summary__row">
              <span className="charge-impact-summary__label">{t('historyPage.revenueChartTotalCharged')}</span>
              <span className="charge-impact-summary__value">
                {formatHistoryKwh(totalKwh)} {t('wt')}
              </span>
            </li>
            <li className="charge-impact-summary__row">
              <span className="charge-impact-summary__label">{t('getBloodyLitersSaved')}</span>
              <a
                href={t('bloodyLitersLink')}
                className="charge-impact-summary__value charge-impact-summary__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {formatImpactCount(litersSaved)} {t('historyPage.revenueChartLitersUnit')}
              </a>
            </li>
            <li className="charge-impact-summary__row">
              <span className="charge-impact-summary__label">{t('historyPage.revenueChartSavedCo2')}</span>
              <span className="charge-impact-summary__value">
                {formatImpactCo2Tons(co2KgSaved)} {t('historyPage.revenueChartCo2Unit')}
              </span>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
